import {
PRODUCT_UPLOAD,
GET_CATEGORIES,
} from '../Action/type';

const initialState = {
    isResistered: false,
    products: {},
    categories:{}
}

export default function (state = initialState, action) {
    switch (action.type) {
        case PRODUCT_UPLOAD:
            return {
                ...state,
                productUpload: action.payload
            };
        case GET_CATEGORIES:
            return {
                ...state,
                categories: action.payload
            };

        default:
            return state;
    }

}

// const initialState = {
//     // pending:false,
// }

// export default function (state = initialState, action) {
//     switch (action.type) {
//         case GET_ERRORS:
//             return {
//                 ...state,
//                 // pending:false,
//                 errors: action.payload
//             }
//             default:
//                 return state;
//     }
    // return {
    //     ...state,
    //     user: action.payload
    // };
// }